import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const UserLogin = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/user-login', {
        identifier,
        password
      });

      // Store user token
      localStorage.setItem('userToken', response.data.token);
      localStorage.setItem('userData', JSON.stringify(response.data.user));
      
      // Custom event for layout update
      window.dispatchEvent(new Event('userTokenChanged'));
      
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-dark px-4">
      <div className="bg-gradient-card p-8 rounded-xl shadow-card border-2 border-gold/30 w-full max-w-md">
        <h1 className="text-3xl font-bold text-center text-gold mb-8">
          Giriş Yap
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="bg-red-500/10 border border-red-500 text-red-500 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          <div>
            <label className="block text-white mb-2 font-medium">
              Kullanıcı Adı veya E-posta <span className="text-gold">*</span>
            </label>
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="kullaniciadi veya email@example.com"
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2 font-medium">
              Şifre <span className="text-gold">*</span>
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifrenizi giriniz"
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
              required
            />
            <div className="mt-2 text-right">
              <Link
                to="/forgot-password"
                className="text-sm text-gold hover:text-gold-light transition-colors"
              >
                Şifremi unuttum
              </Link>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        <div className="mt-6 text-center space-y-2">
          <p className="text-gray-400">
            Hesabınız yok mu?{' '}
            <Link to="/register" className="text-gold hover:text-gold-light transition-colors font-medium">
              Kayıt Ol
            </Link>
          </p>
          <Link to="/" className="text-gold hover:text-gold-light transition-colors text-sm block">
            ← Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
